<div *ngIf="quantidade > 0">
    <span>{{quantidade}}</span>
</div>